import { ConnectorType, ConnectorSource } from '@hum/icm-app/src/state';
import { AvailableServiceInfo } from './base';

export const swellDirectConnector: AvailableServiceInfo = {
  label: 'Swell',
  icon: require('./swell.svg'),
  isBeta: true,
  type: ConnectorType.Swell,
  source: ConnectorSource.Capital,
  fields: [
    {
      label: 'Enter your Client Code',
      propertyName: 'client_code',
    },
    {
      label: 'Enter your Client key',
      propertyName: 'client_key',
    },
  ],
  connect: (params) => params,
};
